import React from 'react';
import RenderViewerId from '@components/viewer-sessions/table/CustomCell/RenderViewerId';

function ViewerIdCell({ rowData }) {
  const { VIEWER_ID } = rowData;
  return <RenderViewerId data={VIEWER_ID} />;
}

export default React.memo(ViewerIdCell);
